import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import ContentLandingPageWrapper from '../Components/ContentLandingPageWrapper';
import ButtonGroup from '../Components/ButtonGroup';
import Button from '../Components/Button';
import Fonts from '../Styles/Fonts';
import Colors from '../Styles/Colors';

const ContactSection = styled.div`
  text-align: center;
`;
const SectionTitle = styled.h2`
  ${Fonts.merriweather.bold};
  font-size: 19px;
  color: ${Colors.white};
`;
const ContactGroup = styled.div`
  margin-top: 14px;
`;
const ContactName = styled.div`
  ${Fonts.spectral.bold};
  font-size: 16px;
  color: ${Colors.white};
`;
const ContactPhone = styled.div`
  ${Fonts.spectral.regular};
  color: ${Colors.white};
  font-size: 16px;

  a {
    color: ${Colors.white};
    text-decoration: none;
  }
`;
const ContactEmail = styled.div`
  ${Fonts.spectral.regular};
  color: ${Colors.blue};
  font-size: 16px;

  a {
    color: ${Colors.white};
    text-decoration: none;
  }
`;

class EventInfoPage extends Component {
  componentDidMount = () => {
  };

  renderPhoneNumber = (contact) => {
    const phone1 = contact.phone_1;
    const phone1Raw = phone1.replace(/\D/g,'');
    const phone2 = (contact && contact.phone_2) ? contact.phone_2 : false;
    const phone2Raw = (contact && contact.phone_2) ? contact.phone_2.replace(/\D/g,'') : false;

    if (phone1 && phone2) {
      return (
        <React.Fragment>
          <a href={`tel:${ phone1Raw }`}>{ phone1 }</a>
          <span> or </span>
          <a href={`tel:${ phone2Raw }`}>{ phone2 }</a>
        </React.Fragment>
      );
    } else {
      return (
        <a href={`tel:${ phone1Raw }`}>{ phone1 }</a>
      );
    }
  }

  renderContacts = () => {
    if (this.props.content && this.props.content.contacts) {
      return this.props.content.contacts.map((contact, index) => {
        return (
          <ContactGroup key={index}>
            <ContactName>{ contact.name.processed }</ContactName>
            <ContactPhone>{ this.renderPhoneNumber(contact) }</ContactPhone>
            <ContactEmail><a href={`mailto:${ contact.email }`}>{ contact.email }</a></ContactEmail>
          </ContactGroup>
        );
      });
    } else {
      return null;
    }
  }

  render() {
    return (
      <ContentLandingPageWrapper headerTitle="Event Info">
        <ButtonGroup>
          <Button to="/event-info/overview">Overview</Button>
          <Button to="/event-info/itinerary">Itinerary</Button>
          <Button to="/event-info/venue-info">Venue Information</Button>
          <Button to="/event-info/attendees">Attendees</Button>
        </ButtonGroup>
        <ContactSection>
          <SectionTitle>{ this.props.content.title }</SectionTitle>
          { this.renderContacts() }
        </ContactSection>
      </ContentLandingPageWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      content: state.content.eventInfoContent
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      performDispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventInfoPage);